<template>
  <div class="page-container">
    <div class="query-title">生产计划最终确认</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="汇总计划项目"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange1"
          @confirm="params => tableConfigConfirm(params, 'xTable')"
        >
          <template #button>
            <table-button name="confirm" tip="最终确认" @click="lastConfirm" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="params => rowClassName(params, 'xTable')"
            @filter-change="evt => filterChangeEvt(evt, 'xTable')"
          >
            <template #lastconfm_qty="{ row }">
              <el-input v-model="row.lastconfm_qty" size="mini" placeholder="请输入" />
            </template>
            <template #abclv="{ row }">
              <el-select
                v-model="row.abclv"
                size="mini"
              >
                <el-option
                  v-for="selectItem in selectDataOptions['level']"
                  :key="selectItem.value"
                  :label="selectItem.name"
                  :value="selectItem.value"
                />
              </el-select>
            </template>
          </vxe-grid>
        </Table-filter>

        <Table-filter
          title="汇总计划"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions2.columns"
          :count-data="countFileds2"
          :all-options="allOptions2"
          :pagination="pagination2"
          @pagination-change="handleTablePaginationChange2"
          @confirm="params => tableConfigConfirm(params, 'xTable2')"
        >
          <vxe-grid
            ref="xTable2"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{ name: 'NotData' }"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions2.columns"
            :data="gridOptions2.data"
            :row-class-name="params => rowClassName(params, 'xTable2')"
            @filter-change="evt => filterChangeEvt(evt, 'xTable2')"
          >
            <template v-for="item in gridOptions2.columns" #[item.field]="{ row }">
              <div :key="item.field">
                <span>{{ row[item.field] }}</span>
              </div>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter
      ref="CustomFilter"
      :current-filter-field="currentFilterField"
      @confirm="customeFilter"
    />
  </div>
</template>

<script>
import { apiGetProdSumConfirmList, apiProdSumHandleLastConfirm } from '@/api/sap/make-plan'
import tableMixins from '@/utils/tableMixins'
import { pageSearch, config1, config2 } from './config/makePlanConfirm'
import { frontExport, exportAll } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      pagination2: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [{ type: 'checkbox', title: '', field: 'checkbox' }],
        data: []
      },
      gridOptions2: {
        columns: [{ type: 'checkbox', title: '', field: 'checkbox' }],
        data: []
      },
      pageSearch,
      searchField: {},
      // 第二个表格
      showHeader2: false,
      sortData2: [],
      tableconfigFilters2: {},
      condition2: {},
      calculation2: null,
      tableCountData2: [],
      filterList2: [],
      tableSort2: [],
      tableFilterData2: {},
      allOptions2: {},
      countFileds2: []
    }
  },
  created() {
    this.searchField = this.pageSearch

    this.initPage(config1, 'gridOptions')
    this.initPage(config2, 'gridOptions2')
  },
  methods: {
    initPage(pageConfig, name = 'gridOptions') {
      const columns = []
      // const searchField = {}
      const keys = Object.keys(pageConfig)
      keys.forEach(key => {
        const obj = {
          field: key,
          title: pageConfig[key].title,
          width: pageConfig[key].width || 120,
          filters: [],
          filterMultiple: false
        }
        if (pageConfig[key].slot) {
          obj.slots = {
            default: key
          }
        }
        // 该字段展示为描述
        if (pageConfig[key].describe) {
          obj.field += '_text'
        }
        columns.push(obj)

        // if (pageConfig[key].type) {
        //   searchField[key] = pageConfig[key]
        // }
      })

      // if (Object.keys(this.pageSearch).length) {
      //   Object.assign(this.pageSearch, searchField)
      //   this.searchField = this.pageSearch
      // } else {
      //   this.searchField = searchField
      // }

      this[name].columns = this[name].columns.concat(columns)
    },
    showList(row) {
      this.$router.push({
        path: '/wly/make-plan/order-edit',
        query: {
          id: row.PRODPL_ID
        }
      })
    },
    queryByCode({ PRODSUM_ID }) {
      this.gridOptions1.data = this.gridOptions1.catchData.filter(v => v.PRODSUM_ID === PRODSUM_ID)
      this.gridOptions2.data = this.gridOptions2.catchData.filter(v => v.PRODSUM_ID === PRODSUM_ID)
    },
    async queryData(page, ranges) {
      // 分页
      if (page === 1) {
        this.pagination.page = page
        this.pagination2.page = page
        if (ranges) {
          this.ranges = ranges
          // this.handleRanges(ranges)
        }
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        prodsumitm: {
          ...this.pagination,
          ...this.condition,
          is_result: 1,
          sort: this.sortData.concat(this.tableSort)
        },
        planord: {
          ...this.pagination2,
          ...this.condition2,
          is_result: 1,
          sort: this.sortData2.concat(this.tableSort2)
        },
        ...this.ranges
      }

      this.loading = true
      try {
        const { prodsumitm, planord } = await apiGetProdSumConfirmList(params)
        if (
          (planord.data.length === 0 && (planord.total - 0)) ||
          (prodsumitm.data.length === 0 && (prodsumitm.total - 0))) {
          this.queryData(1, ranges)
          return
        }
        // 分页
        this.pagination.totalCount = prodsumitm.total - 0
        this.pagination2.totalCount = planord.total - 0
        // 第一个表格
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(prodsumitm.data)
        } else {
          this.gridOptions.data = prodsumitm.data.concat(this.tableCountData)
        }
        // 第二个表格
        if (this.showHeader2) {
          this.gridOptions2.data = this.tableCountData2.concat(planord.data)
        } else {
          this.gridOptions2.data = planord.data.concat(this.tableCountData2)
        }
        // 计算
        this.calculation = this.filtercalculation(prodsumitm.calculation)
        this.calculation2 = this.filtercalculation(planord.calculation, 'xTable2')
        // 更新计算值
        this.updateCount()
        this.updateCount('xTable2')

        // 筛选条件
        this.allOptions = this.filterAllOptions(prodsumitm.field)
        this.allOptions2 = this.filterAllOptions(planord.field, 'xTable2')
        this.setFilter()
        this.setFilter('xTable2')
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 最终确认
    async lastConfirm() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      if (checkedList && checkedList.length) {
        const params = {
          select: checkedList,
          itma: [],
          itmb: []
        }
        const res = await apiProdSumHandleLastConfirm(params)
        if (res.MSGTYPE === 'S') {
          this.$message.success('操作成功')
          this.queryData()
        } else {
          this.$message.warning(res.MESSAGE)
        }
      }
    },
    handleTablePaginationChange1(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    },
    handleTablePaginationChange2(pages) {
      Object.assign(this.pagination2, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/make-plan-manage/makePlanConfirm.vue